import Vue, { CreateElement } from '@src/vue'
import { Component, Prop, Inject, Provide } from 'vue-property-decorator'

import { Link } from '@src/elements/link/link'

import './tabs.sass'

@Component
export class Tab extends Vue {

  @Prop({ required: true })
  label: string

  @Prop({ required: false, default: false })
  selected: boolean

  @Inject()
  container: Tabs

  @Prop({ required: false })
  selectTab: (value: string) => void

  mounted () {
    this.container.tabs.push(this)
  }

  render (h: CreateElement) {
    return <div class={'component-tab' + (this.selected ? ' selected' : '')}>

      <div class='header'>
        <Link label={this.label} click={
          () => {
            this.container.selectTab(this)
          }
        } />
      </div>

      {
        this.selected ? <div class='body'>{
          this.$slots.default
        }</div> : null
      }

    </div>
  }

  setSelected (selected: boolean) {
    if (selected && this.selectTab) {
      this.selectTab(this.label)
    }
  }

}

@Component
export class Tabs extends Vue {

  @Provide()
  container = this

  tabs: Tab[] = []

  render (h: CreateElement) {
    return <div class='component-tabs'>
      {
        this.$slots.default
      }
    </div>
  }

  selectTab (tab: Tab) {
    for (let tab of this.tabs) {
      tab.setSelected(false)
    }

    tab.setSelected(true)
  }

}
